<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div
        class="page-card__header"
        style="line-height: 40px; height: 40px;"
      >
        <el-row>
          <el-col :span="6">
            <span style="padding-right: 20px"> 登记公司（共{{ aSum }}人）</span>
          </el-col>
          <el-col :span="6">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%; padding: 0 20px">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="company" label="公司名称"></el-table-column>
      <el-table-column prop="linkman" label="联系人"></el-table-column>
      <el-table-column prop="position" label="职务"></el-table-column>
      <el-table-column prop="phone_number" label="电话"></el-table-column>
      <el-table-column prop="is_exh" label="预定展位">
        <template slot-scope="{ row }">
          {{ row.is_exh == true ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="留言"></el-table-column>
      <!-- <el-table-column prop="type" label="类型">
        <template slot-scope="{ row }">
          <span v-if="row.type == 1">紧固件</span>
          <span v-if="row.type == 2">汽车产业链（协会）</span>
          <span v-if="row.type == 3">汽车零部件</span>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="create_time"
        label="填写时间"
        sortable
      ></el-table-column>

      <el-table-column prop="is_sms" label="短信通知">
        <template slot-scope="{ row }">
          <el-tag v-if="row.is_sms" type="success">已发送</el-tag>

          <el-tooltip
            v-if="row.is_sms == false"
            class="item"
            effect="dark"
            :content="row.sms_err"
            placement="left"
          >
            <el-tag type="danger">发送失败</el-tag>
          </el-tooltip>

          <el-tag v-if="row.is_sms == null" type="info">无记录</el-tag>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.is_pay"
            type="text"
            @click="PlayClick(scope.row)"
          >付款
          </el-button>
          <el-button
            v-if="scope.row.is_pay"
            type="text"
            disabled
          >已付款
          </el-button>
          <el-button
            type="text"
            class="action-btn--danger"
            @click="handleClick(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  data() {
    return {
      tableData: [],
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
      currentPage: 1,
      aSum: 0,
      input: "",
      type: 7,
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    this.type = to.query.type;
    this.getData();
    next();
  },
  methods: {
    // 获取登记公司数据
    getData() {
      let url;
      if (this.type == 1) {
        url = this.baseUrl + "/admin/cn_tha/?type__in=1,2,3";
      } else {
        url = this.baseUrl + "/admin/cn_tha/?type=" + this.type;
      }

      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 搜索登记公司
    serach() {
      let url;
      if (this.type == 1) {
        url =
          this.baseUrl +
          "/admin/cn_tha/?type__in=1,2,3" +
          "&search=" +
          this.input;
      } else {
        url =
          this.baseUrl +
          "/admin/cn_tha/?type=" +
          +this.type +
          "&search=" +
          this.input;
      }

      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url;
      if (this.type == 1) {
        url =
          this.baseUrl +
          "/admin/cn_tha/?type__in=1,2,3" +
          "&page=" +
          val +
          "&search=" +
          this.input;
      } else {
        url =
          this.baseUrl +
          "/admin/cn_tha/?type=" +
          this.type +
          "&page=" +
          val +
          "&search=" +
          this.input;
      }

      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除登记公司记录
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/cn_tha/" + a_id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },

    // 标记为已付款
    PlayClick(row) {
      this.$confirm("将此条信息改为已付款，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/cn_tha/" + a_id + "/";
        const play_time = new Date();
        api
          .patchData(url, { is_pay: 1, pay_time: play_time })
          .then((res) => {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getData();
          });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .vue-html5-editor > .content {
  max-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/cnGlobalList.vue